export function desdePorcentaje(porcentaje: number, total: number) {
  return (porcentaje / 100) * total;
}

export function porcentaje(seccion: number, total: number) {
  return (seccion / total) * 100;
}
